import { useEditor } from "@smartfire/js-block-engine";
import { useState, useEffect } from "react";
import { Skeleton } from "@mui/material";
import clsx from "clsx";
import style from "./style.module.scss";

const Brand = ({ brand }) => {
  const { isEditing } = useEditor();
  const [imageLoaded, setImageLoaded] = useState(false);
  const Tag = isEditing ? "div" : "a";

  useEffect(() => {
    if (brand?.image?.url) {
      const img = new Image();
      img.src = brand.image.url;
      img.onload = () => setImageLoaded(true);
    }
  }, [brand]);

  return brand?.image?.url ? (
    <Tag href={!isEditing ? brand?.link : undefined}>
      {!imageLoaded && (
        <Skeleton
          variant="rectangular"
          className={clsx(style.skeletonImage, style.mainImage)}
        />
      )}
      <img
        className={style.mainImage}
        alt={brand?.image?.alt || brand.title}
        src={brand?.image?.url}
        style={{ display: imageLoaded ? "block" : "none" }}
        loading="lazy"
      />
    </Tag>
  ) : (
    <div className={clsx(style.skeletonImage, style.mainImage)}></div>
  );
};

export default Brand;